module.exports = __webpack_public_path__ + "static/media/sheets_white_icon.42fc37c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sheets_white_icon.png
// module id = 1227
// module chunks = 0